export default __webpack_public_path__ + "218093eef00aa9e80163a9a407b363e6.svg";